export const constants = {
  ROOM_FEATURES_CODES: ['CR', 'RB', 'EP', 'EF', 'FP', 'FF'],
  STAY_CODES: ['EC'],
  BATHROOM_CODES: ['ET'],
  FEATHER_CODES: ['EP', 'FF'],
  FEATHER_PILLOW_CODE: 'EP',
  PILLOW_CODES: ['EP', 'FP', 'EF'],
  HOUSEKEEPING_OPT_IN: 'HA',
  HOUSEKEEPING_CODES: ['HD', 'HA'],
  HOUSEKEEPING_OPT_OUT: 'HD',
  MARRIOTT_BRAND_CODE: 'MC',

  // Housekeeping codes
  HK_EXCLUDED_BRAND_LIST: ['ER', 'MV', 'RZ', 'EB', 'WH', 'LC', 'XR', 'JW', 'BG'],

  // brands that need to redirected to the landing page instead of the reviews page
  HWSLandingPageRedirectionBrands: ['RZ', 'MV', 'DS', 'BG'],

  // Room Preferences Codes
  PREFERENCES_EXCEPTION_CODE: ['S5', 'D7', 'D9', 'N8', 'U2', 'W5', 'UR', 'M2'],
  ROOM_LOCATIONS_CODES: ['H1', 'L2', 'NE'],
  FLOOR_CODES: ['L2', 'H1'],

  ADDITIONAL_RF: 'RF',

  // Payment Codes
  PLUS_PAYMENT_METHOD_CODE_TYPE: 'SpecialIndustryProgram',
  PAYMENT_METHOD_CODE_TYPE_DEPOSITE: ['Cash', 'PrePay', 'Deposit'],
  PAYMENT_METHOD_CODE_TYPE_GUARANTEE: [
    'DirectBill',
    'Voucher',
    'CreditCard',
    'TravelAgencyIATANumber',
    'FrequentGuestNumber',
    'SpecialIndustryProgram',
    'CompanyNameOrAddress',
    'CorporateIDOrCDNumber',
    'OtherInformation',
    'PaymentManager',
  ],
  DEFAULT_PMT: 'CreditCard',

  HOTEL_ICON_CODES: {
    HOTEL_SERVICES: 'SA',
    HOTEL_HIGHLIGHTS: 'HH',
    PARKING: 'PT',
    HOUSEKEEPING: '10',
  },
  GUEST_ROOM_FIELD: 'ASP301',

};
